"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _markets = require("@/model/markets/markets");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _keymap = require("@/assets/js/keymap.js");

var _vuex = require("vuex");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { formatSeconds } from "@/assets/js/formatDate";
var _default2 = {
  mixins: [_commonMixin.default],
  props: {
    swap_symbol_id: {
      type: [String, Number],
      default: function _default() {
        return 100901;
      }
    },
    tradePairArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: [String, Number]
    }
  },
  data: function data() {
    return {
      systemCurrencyMaps: _keymap.systemCurrencyMaps,
      multipleNum: 20,
      timer: null,
      multipleNumBtn: false,
      colorClass: "",
      fundForm: {
        fund_rate: "",
        time: 0
      },
      selfOptionsList: []
    };
  },
  created: function created() {
    // let tempMultipleNum = localStorage.getItem("stock-multiple-num");
    // if (tempMultipleNum) {
    //   this.multipleNum = tempMultipleNum;
    // }
    this.getOptionList(); // this.getFundingRate();
    // this.startTimer();
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    //将秒数转换为时分秒格式
    formatSeconds: function formatSeconds(s) {
      var t;

      if (s > -1) {
        var hour = Math.floor(s / 3600);
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;

        if (hour < 10) {
          t = "0" + hour + ":";
        } else {
          t = hour + ":";
        }

        if (min < 10) {
          t += "0";
        }

        t += min + ":";

        if (sec < 10) {
          t += "0";
        }

        t += sec.toFixed(0);
      }

      if (t == "00:00:00") {
        t = "--";
      }

      return t;
    },
    startTimer: function startTimer() {
      var _this = this;

      this.timer = setTimeout(function () {
        _this.getFundingRate();

        _this.startTimer();
      }, 1000);
      this.$once("hook:beforeDestroy", function () {
        clearTimeout(_this.timer);
      });
    },
    // onMultipleNumClick() {
    //   this.$emit("onMultipleNumClick", this.multipleNum);
    // },
    setMultipleNum: function setMultipleNum(value) {
      this.multipleNum = value;
    },
    getFundingRate: function getFundingRate() {
      var _this2 = this;

      if (this.swap_symbol_id) {
        var params = {
          symbol_id: this.swap_symbol_id
        };
        return (0, _markets.apiGetFundingRate)(params).then(function (res) {
          if (res.status == 200) {
            _this2.fundForm = res.data;
          }
        });
      }
    },
    getOptionList: function getOptionList() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$Account$getUse, userInfo;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Account.getUserInfo();

              case 2:
                _yield$Account$getUse = _context.sent;
                userInfo = _yield$Account$getUse.userInfo;

                if (userInfo) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                (0, _markets.apiGetOptionList)().then(function (res) {
                  if (res.status == 200) {
                    if (JSON.stringify(res.data) != "{}" && res.data.digital) {
                      _this3.selfOptionsList = res.data.digital;
                    }
                  }
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addOption: function addOption(type) {
      var _this4 = this;

      if (this.userInfo) {
        var params = {
          symbol_id: this.swap_symbol_id,
          option: type,
          swap_type: 2
        };
        (0, _markets.apiAddOption)(params).then(function (res) {
          if (res.status == 200) {
            _this4.getOptionList();

            _this4.$emit("onAddOption");

            _this4.$message({
              message: params.option == 1 ? _this4.translateTitle("\u6DFB\u52A0\u81EA\u9009\u6210\u529F") : _this4.translateTitle("\u5220\u9664\u81EA\u9009\u6210\u529F"),
              type: params.option == 1 ? "success" : "success"
            });
          }
        });
      } else {
        this.$router.push({
          path: this.routeSplicing(this.language, "login"),
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
    }
  },
  watch: {
    swap_symbol_id: function swap_symbol_id() {
      var _this5 = this;

      var tempMultipleNum = JSON.parse(localStorage.getItem("stock-multiple-num"));

      for (var key in tempMultipleNum) {
        if (key == this.swap_symbol_id) {
          this.multipleNumBtn = true;
          this.multipleNum = Number(tempMultipleNum[key]);
          setTimeout(function () {
            _this5.multipleNumBtn = false;
          }, 1000);
        }
      }

      if (this.multipleNumBtn == false) {
        this.multipleNum = 20;
      }
    },
    marketInfoShow: function marketInfoShow(newValue, oldValue) {
      if (Number(newValue.last) - Number(oldValue.last) > 0) {
        this.colorClass = "green";
      } else if (Number(newValue.last) - Number(oldValue.last) < 0) {
        this.colorClass = "red";
      }
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    systemCurrency: "user/currency",
    language: "user/language"
  })), {}, {
    from_symbol_show: function from_symbol_show() {
      return this.from_symbol.toUpperCase() || "--";
    },
    to_symbol_show: function to_symbol_show() {
      return this.to_symbol.toUpperCase() || "--";
    },
    marketInfoShow: function marketInfoShow() {
      var _this6 = this;

      // this.pageLoading = true;
      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this6.swap_symbol_id) {
          marketInfo = ele;
        }
      }); // this.pageLoading = false;

      return marketInfo;
    },
    className: function className() {
      var className = "";

      if (!this.marketInfoShow.price_change_percent) {
        className = "";
      } else if (this.marketInfoShow.price_change_percent > 0) {
        className = "green";
      } else if (this.marketInfoShow.price_change_percent < 0) {
        className = "red";
      }

      return className;
    }
  })
};
exports.default = _default2;